/// <amd-module name="SuiteCommerce.GiftCertificate.Currency.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.Currency.Model", ["require", "exports", "Backbone"], function (require, exports, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CurrencyModel = void 0;
    var CurrencyModel = /** @class */ (function (_super) {
        __extends(CurrencyModel, _super);
        function CurrencyModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(CurrencyModel.prototype, "id", {
            get: function () {
                return this.get('id');
            },
            set: function (id) {
                this.set('id', id);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(CurrencyModel.prototype, "name", {
            get: function () {
                return this.get('name');
            },
            set: function (name) {
                this.set('name', name);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(CurrencyModel.prototype, "symbol", {
            get: function () {
                return this.get('symbol');
            },
            set: function (symbol) {
                this.set('symbol', symbol);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(CurrencyModel.prototype, "symbolPlacement", {
            get: function () {
                return this.get('symbolPlacement');
            },
            set: function (symbolPlacement) {
                this.set('symbolPlacement', symbolPlacement);
            },
            enumerable: false,
            configurable: true
        });
        return CurrencyModel;
    }(Backbone_1.Model));
    exports.CurrencyModel = CurrencyModel;
});
